/**
 * @generated SignedSource<<76cdf199aa0a05172e0a6e7697b4ba67>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LandlordCreateOnboardingDraftResponseFailure = "PREVIEW_NOT_FOUND" | "%future added value";
export type LandlordCreateOnboardingDraftInput = {
  previewId: string;
};
export type useStartCreateOnboardingDraftMutation$variables = {
  input: LandlordCreateOnboardingDraftInput;
  turnstileToken: string;
};
export type useStartCreateOnboardingDraftMutation$data = {
  readonly landlordCreateOnboardingDraft: {
    readonly draft: {
      readonly id: string;
    } | null | undefined;
    readonly failures: ReadonlyArray<LandlordCreateOnboardingDraftResponseFailure> | null | undefined;
  } | null | undefined;
};
export type useStartCreateOnboardingDraftMutation = {
  response: useStartCreateOnboardingDraftMutation$data;
  variables: useStartCreateOnboardingDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "turnstileToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "turnstileToken",
        "variableName": "turnstileToken"
      }
    ],
    "concreteType": "LandlordCreateOnboardingDraftResponse",
    "kind": "LinkedField",
    "name": "landlordCreateOnboardingDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LandlordOnboardingDraft",
        "kind": "LinkedField",
        "name": "draft",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failures",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useStartCreateOnboardingDraftMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useStartCreateOnboardingDraftMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "e87ff1d05982b6925bee844ad3d64909",
    "id": null,
    "metadata": {},
    "name": "useStartCreateOnboardingDraftMutation",
    "operationKind": "mutation",
    "text": "mutation useStartCreateOnboardingDraftMutation(\n  $input: LandlordCreateOnboardingDraftInput!\n  $turnstileToken: String!\n) {\n  landlordCreateOnboardingDraft(input: $input, turnstileToken: $turnstileToken) {\n    draft {\n      id\n    }\n    failures\n  }\n}\n"
  }
};
})();

(node as any).hash = "686a6793da5475ea2e84493cb8c6d5bb";

export default node;
